import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
// IMPORTING BOOTSTRAP CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import WebRoutes from './Routes/WebRoutes'
import './i18n'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { initializeCustomerDisplayTabId } from 'Views/CustomerDisplay/utils/customerDisplayChannel'
import Loading from 'Components/Loading'
// import reportWebVitals from './reportWebVitals';

globalThis.addEventListener(
  'error',
  e => {
    if (
      e.message ===
      'ResizeObserver loop completed with undelivered notifications.'
    ) {
      e.stopImmediatePropagation()
      e.preventDefault()
    }
  },
  true
)

const queryClient = new QueryClient()

const customerDisplayTabIdInitialization =
  initializeCustomerDisplayTabId().catch(error => {
    console.warn(
      'No se pudo inicializar la identidad de la pestaña para Customer Display:',
      error
    )
  })

function AppBootstrap() {
  const [isTabIdentityReady, setIsTabIdentityReady] = useState(false)

  useEffect(() => {
    let isMounted = true

    customerDisplayTabIdInitialization.finally(() => {
      if (isMounted) {
        setIsTabIdentityReady(true)
      }
    })

    return () => {
      isMounted = false
    }
  }, [])

  return isTabIdentityReady ? <WebRoutes /> : <Loading full />
}

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <AppBootstrap />
  </QueryClientProvider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
